import { PERMISSIONS } from '@app/core/constants/permissions.constants'
import type { PermissionService } from '@core/services/permission-service/permission-service'
import { BANNER_PAUSE_RESUME_ROLES } from '../constants/banner-list.constants'
import type { BannerCampaignStatus } from '../models/banner-campaign.model'

/** True when the user may open the EI Banner admin surface. */
export function canAccessEiBannerAdmin(
    permissionService: PermissionService,
    userTypeRaw?: string | null,
): boolean {
    const userType = userTypeRaw?.trim().toLowerCase() ?? ''
    if (BANNER_PAUSE_RESUME_ROLES.has(userType)) {
        return true
    }
    return permissionService.canAccessPermissionOrImplicitFullAccess(PERMISSIONS.MANAGE_EI_BANNER)
}

/** Shared edit rule for list actions and direct edit-route deep links. */
export function canEditBannerCampaign(
    campaign: { status: BannerCampaignStatus; created_by?: string | null },
    currentUserId: string | null | undefined,
): boolean {
    const userId = currentUserId?.trim()
    const createdBy = campaign.created_by?.trim()
    if (!userId || !createdBy) return false
    if (createdBy.toLowerCase() === 'system') return false
    if (userId !== createdBy) return false
    return campaign.status === 'draft' || campaign.status === 'rejected'
}
